import { render, staticRenderFns } from "./Search_ProductLots_Detail.vue?vue&type=template&id=b70315b2&scoped=true&"
import script from "./Search_ProductLots_Detail.vue?vue&type=script&lang=js&"
export * from "./Search_ProductLots_Detail.vue?vue&type=script&lang=js&"
import style0 from "./Search_ProductLots_Detail.vue?vue&type=style&index=0&id=b70315b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70315b2",
  null
  
)

export default component.exports